import React, { useContext, useEffect } from 'react';

import { Loading as LoadingComponent } from '~/components';
import history from '~/config/history';
import { Context as QueryContext } from '~/contexts/QueryContext';
import { PATHS } from '~/routes/paths';
import api, { Endpoints } from '~/services/api';

import { Container, Overlay } from './styles';

const Loading = () => {
  const { params } = useContext(QueryContext);

  useEffect(() => {
    async function getStatus(id) {
      try {
        const { data } = await api.get(Endpoints.BUSCAR_DADOS + id);
        const { data: lastStatus } = await api.get(Endpoints.ULTIMO_STATUS + id);

        let path = PATHS.acionamento;
        switch (lastStatus?.status?.ordem) {
          case 5:
            path = PATHS.acionamento_finalizado;
            break;
          case 6:
            path = PATHS.valor_excedente;
            break;
          case 7:
            path = PATHS.valor_excedente_finalizado;
            break;
          default:
            break;
        }

        history.replace(path, {
          ...data,
          nomeCliente: data.titular,
          numServico: data.numeroServico,
          dataAbertura: data.dataAberturaAssistencia,
        });
      } catch (error) {
        console.error(error);
        history.replace(PATHS.notfound);
      }
    }

    if (params?.idAssistServico) {
      getStatus(params.idAssistServico);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params]);

  return (
    <Container>
      <LoadingComponent />
      <Overlay />
    </Container>
  );
};

export default Loading;
